module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleAnalytics":{"trackingId":"G-ZTM28LE0V8","cookieName":"gatsby-gdpr-google-analytics","anonymize":true,"allowAdFeatures":true},"facebookPixel":{"pixelId":"711961694803201","cookieName":"gatsby-gdpr-facebook-pixel"},"environments":["production","development"]},
    },{
      plugin: require('../node_modules/gatsby-theme-material-ui-top-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"pathToEmotionCacheProps":""},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Turnoflex","short_name":"Turnoflex","start_url":"/","scope":"/","background_color":"#505656","theme_color":"#5C9EAD","display":"standalone","lang":"es","icon":"src/images/mask-icon/turnoflex-mask-icon-512.png","cache_busting_mode":"name","shortcuts":[{"name":"Modo Consumidor","short_name":"Consumidor","description":"Abrir modo consumidor","url":"/app/reservations/"},{"name":"Modo Negocio","short_name":"Negocio","description":"Abrir modo negocio","url":"/settings/"}],"legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6c17d1d4be65524c6e32e3c93410f71b"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline-next/gatsby-browser.js'),
      options: {"plugins":[],"offlineGoogleAnalytics":true,"cleanupOutdatedCaches":true,"swSrc":"/opt/build/repo/ui/web/app/src/custom-sw.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#5C9EAD","showSpinner":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
